import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { createPipeline } from '@ff-os/rendering-react/createPipeline';
import { createTransform, createUndoViewbox, Spaces, UndoViewbox } from '@ff-os/rendering-shared/coordinates';
import { toBlob } from '@ff-os/shared-react/dom/images/toBlob';
import { maintainAspectRatioOf } from '@ff-os/shared-utils/aspect-ratios';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { GiftVariantOptions } from '@ff-scene-plugins/gift-shared/GiftVariantOptions';
import { createDOMCanvas, Paintable, Size } from 'ff-canvas';
import { noop } from 'lodash';
import { createBackgroundPaintable } from './preview/helpers/createBackgroundPaintable';

export const renderGiftThumbnail = async (
    paintables: Paintable[],
    variant: GiftJson.Variant<GiftVariantOptions>,
    spaces: Spaces,
    sceneSize: Size,
    targetSize: Size,
    language: string,
    renderBackground: boolean
): Promise<Pdp.Scene.RenderThumbnailResult> => {

    const outputSize = maintainAspectRatioOf(sceneSize, targetSize);

    if (variant.options.backgroundAssetUrl && renderBackground) {
        paintables.push(createMockupPaintable(
            sceneSize,
            variant.options.backgroundAssetUrl,
            createUndoViewbox(spaces)));
    }

    const thumbnail = await render(paintables, outputSize, spaces, language);
    return {
        toBlob: async () => await toBlob(thumbnail),
        toBase64: async () => thumbnail.toDataURL()
    };
};

const createMockupPaintable = (
    sceneSize: Size,
    backgroundAssetUrl: string,
    undoViewbox: UndoViewbox
) => {
    return createBackgroundPaintable(
        sceneSize.width, sceneSize.height,
        undoViewbox,
        backgroundAssetUrl!);
};

const render = async (
    paintables: Paintable[],
    outputSize: Size,
    spaces: Spaces,
    language: string
) => {

    const canvas = createDOMCanvas();
    canvas.width = outputSize.width;
    canvas.height = outputSize.height;

    const pipeline = createPipeline(canvas, { t: a => a, language }, {
        requestRender: noop,
        transform: createTransform(outputSize.width, outputSize.height, spaces),
        useDevicePixelRatio: false
    });

    await pipeline.preloadResources(paintables);
    pipeline.paintAll(paintables);
    return canvas;
};